import styled from "@emotion/styled";
import theme from "@theme/";

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: ${theme.gradient.themeGradient};
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const BodyContainer = styled.div`
  margin-top: 60px;
  background: ${theme.gradient.backgroundTheme};
  min-height: calc(100vh - 60px);
`;

const HeadingTag = styled.p`
  float: left;
  margin: 8px;
  padding: 0px 24px 0px 0px;
  font-weight: 600;
  font-size: 16px;
  color: #2d3748;
`;

const FilterContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 16px 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

const FilterOption = styled.p`
  padding: 8px 0px;
  color: #4a5568;
  font-weight: 500;
`;

const Container = styled.div`
  padding: 24px;
  max-width: 1500px;
  margin: 0 auto;
`;

const ActiveContainer = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    padding: 24px;
  }
`;

const ImageContainer = styled.div`
  width: 180px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: #f8fafc;
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.15);
  border: 1px solid rgba(227, 110, 0, 0.1);
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    width: 100%; // full width on mobile
    max-width: 150px; // optional: limit max size
    height: 50px; // adjust height
  }
`;

const Image = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(227, 110, 0, 0.1);
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.15);
`;

const ProjectDiv = styled.div`
  margin-left: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
  }
`;

const PropertyName = styled.span`
  font-weight: 700;
  font-size: 28px;
  background: ${theme.gradient.themeGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0;
  letter-spacing: -0.5px;
  display: inline-block;
  vertical-align: middle;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Status = styled.div`
  color: ${(props) =>
    props.currentProject.status === 1 ? "#10b981" : "#ef4444"};
  font-weight: 600;
  font-size: 14px;
  margin: 0 0 0 16px;
  padding: 6px 12px;
  background: ${(props) =>
    props.currentProject.status === 1
      ? "rgba(16, 185, 129, 0.1)"
      : "rgba(239, 68, 68, 0.1)"};
  border-radius: 20px;
  display: inline-block;
  width: fit-content;
  border: 1px solid
    ${(props) =>
      props.currentProject.status === 1
        ? "rgba(16, 185, 129, 0.2)"
        : "rgba(239, 68, 68, 0.2)"};
  vertical-align: middle;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Email = styled.span`
  font-size: 16px;
  color: #6b7280;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;

  &::before {
    content: "📧";
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const ButtonContaiiner = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 20px 24px;
  margin: 0 0 24px 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;
const TabContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 8px;
  margin: 0 0 24px 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  // display: flex;
  // gap: 8px;
  // flex-direction: column;
`;

const ContentContainer = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  FilterContainer,
  FilterOption,
  ActiveContainer,
  ImageContainer,
  Image,
  ProjectDiv,
  PropertyName,
  Status,
  Email,
  ButtonContaiiner,
  TabContainer,
  ContentContainer,
};

export default SC;
